"use client";

import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";
import { memo } from "react";

type OrderCardItemProps = {
  className?: string;
  label: React.ReactNode;
  valueClassName?: string;
  size?: "md" | "lg";
  direction?: "row" | "column";
} & React.ComponentProps<"div">;

export const OrderCardItem = memo(
  ({
    className,
    label,
    children,
    valueClassName,
    size = "md",
    direction = "row",
  }: OrderCardItemProps) => {
    const variant = size === "lg" ? "labelFixedLg" : "labelFixedMd";
    const isColumn = direction === "column";

    return (
      <div
        className={cn( "break-all",
          { "grid grid-cols-1 gap-2": isColumn },
          { "flex items-center justify-between gap-4": !isColumn },
          className
        )}
      >
        <Typography variant={variant} asChild>
          <div>{label}</div>
        </Typography>
        {children && (
          <Typography variant={variant} className={valueClassName} asChild>
            <span>{children}</span>
          </Typography>
        )}
      </div>
    );
  }
);

export default OrderCardItem;
